import classes from "./PhoneOptions.module.css";
import ActivityResults from "./results/ActivityResults";
import LocationResults from './results/LocationResults';

export const PhoneOptions = ({ localActiveInput, setLocalActiveInput, setIsButtonEnabled }) => {
  return (
    <>
      <div className={classes.resultsContainer}>
        {localActiveInput === 'activity' && (
          <ActivityResults 
            setIsButtonEnabled={setIsButtonEnabled} 
            setLocalActiveInput={setLocalActiveInput}
          />
        )}
        {localActiveInput === 'location' && (
          <LocationResults 
            setIsButtonEnabled={setIsButtonEnabled} 
            setLocalActiveInput={setLocalActiveInput} 
          />
        )}
      </div>
    </>
  );
};

export default PhoneOptions;
